'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customEventInsert from './tpl/customEventInsert.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_DialogBox from '../../../lib/views/dialogBox/dialogBox';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Empty from '../../../lib/entities/empty';

import helper_createWebpage from '../../helper/createWebpage';
import helper_createEvent from '../../helper/createEvent';
import config from '../../../common/config';
import View_Render from '../../views/render/render';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_customEventInsert();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    ui: {
        'customEventInsert_btnSubmit': '#customEventInsert_btnSubmit',
        'customEventInsert_btnSubmitAdmin': '#customEventInsert_btnSubmitAdmin',
        'customEventInsert_inputName': '#customEventInsert_inputName',
        'customEventInsert_rDefault': '#customEventInsert_rDefault',
        'customEventInsert_rEmpty': '#customEventInsert_rEmpty',
        'customEventInsert_btnTest': '#customEventInsert_btnTest',
        'customQRCodeInsert_qrCodeContainer': '#customQRCodeInsert_qrCodeContainer',
        'customQRCodeInsert_container': '#customQRCodeInsert_container',
        'customQRCodeInsert_qrCodeLogo': '#customQRCodeInsert_qrCodeLogo'
    },
    events: {
        'click @ui.customEventInsert_btnSubmit': 'btnSubmitClick',
        'click @ui.customEventInsert_btnSubmitAdmin': 'btnSubmitAdminClick',
        'click @ui.customEventInsert_btnTest': 'btnSubmitTest',
    },
    childEvents: {
        'table_addModel': function (childView, msg) {
        }
    },
    onRender: function () {
        this.ui.customEventInsert_rDefault.prop('checked', true);
        this.ui.customEventInsert_rEmpty.prop('checked', false);

        if (this.app.entities.models.custom.attributes.Admin) {
            this.ui.customEventInsert_btnSubmitAdmin.show();
        } else {
            this.ui.customEventInsert_btnSubmitAdmin.css('display', 'none');
        }
    },
    //Create a default event, now create from language and name and dafault or name and empty
    btnSubmitAdminClick: function () {
        var self = this;
        var errors = [];


        if (self.$el.find('#customEventInsert_inputName').val() == "") {
            errors.push({ name: 'customEventInsert_inputName', message: resources.X100324 });
        }

        for (var i = 0; i < app.entities.collections.customEvent.fullCollection.length; i++) {
            if (self.$el.find('#customEventInsert_inputName').val() == app.entities.collections.customEvent.fullCollection.models[i].attributes.Name) {
                errors.push({ name: 'customEventInsert_inputName', message: resources.X100327 });
            }
        };

        if (errors.length > 0) {
            self.hideErrors();
            self.showErrors(errors);
        }
        else {
            self.hideErrors();


            var dialogWaitingModel = new Entities_Empty.Model();
            dialogWaitingModel.attributes.Title = resources.X100070;
            dialogWaitingModel.attributes.Text = resources.X100305;
            dialogWaitingModel.attributes.Button = resources.X100279;

            var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });

            var fetchCallback = function (id) {
                self.app.entities.collections.customModule.fetch({
                    EventId: id,
                    success: function (mode, response) {
                    },
                    error: function (mode, response) {
                    }
                });
            }

            var callback = function (id) {
                dialogWaiting.triggerMethod('dialog:close');
                self.stopListening(dialogWaiting, "dialog:okclicked", callback);

                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: id })
                var render = new View_Render({ collection: customEvent, app: self.app });
                self.app.renderRegion.show(render);
                var renderFinishCallback = function (options) {
                    $('.modal-backdrop').remove();
                    var scroll = $(document).scrollTop();
                    window.app.router.navigate("#customEventEditItem/" + id);
                    var scroll = $(document).scrollTop();
                    window.app.router.customEventEditItem(id, scroll, 0, 1, true, false);
                    $('.modal-backdrop').remove();
                }
                render.doIt(renderFinishCallback, true, 'EVENTINFO_REFRESH', false);
            }


            var fetchCallback = function (id) {
                self.app.entities.collections.customModule.fetch({
                    EventId: id,
                    success: function (mode, response) {
                        callback(id);
                    },
                    error: function (mode, response) {
                    }
                });
            }

            self.listenTo(dialogWaiting, "dialog:okclicked");
            self.app.dialogRegion.show(dialogWaiting);

            var lat = 0;
            var lng = 0;

            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'address': this.app.entities.models.custom.attributes.Address_country }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    lat = results[0].geometry.location.lat();
                    lng = results[0].geometry.location.lng();

                    helper_createEvent.createEventDefault(self.app, self, lat, lng, self.$el.find('#customEventInsert_inputName').val(), fetchCallback);

                } else {
                    lat = 0;
                    lng = 0;

                    helper_createEvent.createEventDefault(self.app, self, lat, lng, self.$el.find('#customEventInsert_inputName').val(), fetchCallback);
                }
            });
        }
    },
    //Create a default event, now create from language and name and dafault or name and empty
    btnSubmitClick_old: function () {
        var _default = true;

        this.ui.customEventInsert_rDefault.is(':checked') ? _default = true : _default = false;

        var self = this;
        var dialogWaitingModel = new Entities_Empty.Model();
        dialogWaitingModel.attributes.Title = resources.X100070;
        dialogWaitingModel.attributes.Text = resources.X100305;
        dialogWaitingModel.attributes.Button = resources.X100279;

        var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });

        var callback = function (id) {
            dialogWaiting.triggerMethod('dialog:close');
            self.stopListening(dialogWaiting, "dialog:okclicked", callback);

            var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: id })
            var render = new View_Render({ collection: customEvent, app: self.app });
            self.app.renderRegion.show(render);
            var renderFinishCallback = function (options) {
                var scroll = $(document).scrollTop();
                window.app.router.navigate("#customEventEditItem/" + id);
                var scroll = $(document).scrollTop();
                window.app.router.customEventEditItem(id, scroll, 0, 1, true, false);
            }
            render.doIt(renderFinishCallback, true, 'EVENTINFO_REFRESH', false);
        }
        self.listenTo(dialogWaiting, "dialog:okclicked");
        self.app.dialogRegion.show(dialogWaiting);

        var lat = 0;
        var lng = 0;

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': this.app.entities.models.custom.attributes.Address_country }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                lat = results[0].geometry.location.lat();
                lng = results[0].geometry.location.lng();

                helper_createEvent.createEventDefault(self.app, self, lat, lng, self.$el.find('#customEventInsert_inputName').val(), callback);

            } else {
                lat = 0;
                lng = 0;

                helper_createEvent.createEventDefault(self.app, self, lat, lng, self.$el.find('#customEventInsert_inputName').val(), callback);
            }
        });
    },
    btnSubmitClick: function () {
        var count = 0;

        //this.app.entities.collections.customEvent.fullCollection.forEach(function (entry) {
        //    if (entry.attributes.Enable == true) count++;
        //});

        //if (count >= this.app.entities.models.customItem.attributes.Count) {
        //    tmpModel.attributes.Enable = false;
        //}
        //else {
        //    tmpModel.attributes.Enable = true;
        //}

        var categoryEmpty = this.app.entities.collections.Category.where({ Empty: true })[0];
        var categoryDefault = this.app.entities.collections.Category.where({ Default: true })[0];
        var categoryNone = this.app.entities.collections.Category.where({ None: true })[0];

        var templateEmpty = this.app.entities.collections.customEventTemplate.fullCollection.where({ Category01: categoryEmpty.attributes.Value })[0];
        var templateDefault = this.app.entities.collections.customEventTemplate.fullCollection.where({ Category01: categoryDefault.attributes.Value })[0];

        var sourceId = -1;
        this.ui.customEventInsert_rDefault.is(':checked') ? sourceId = templateDefault.attributes.Event : sourceId = templateEmpty.attributes.Event;

        var self = this;

        var name = self.$el.find('#customEventInsert_inputName').val();

        var callbackCreateEventDone = function (destId) {
            var tmpModel = new Entities_Empty.Model();

            var tmpModel = new self.app.entities.collections.customEventTemplate.fullCollection.model();
            tmpModel.attributes.AuthUserId = config.authUserId();


            //Not used but value has to be something
            if (self.ui.customEventInsert_rDefault.is(':checked')) {
                tmpModel.attributes.Event = templateDefault.attributes.Event;
                tmpModel.attributes.CultureName = templateDefault.attributes.CultureName;
                tmpModel.attributes.Name = templateDefault.attributes.Name;
                tmpModel.attributes.EventName = templateDefault.attributes.EventName;
                tmpModel.attributes.Description = templateDefault.attributes.Description;
                tmpModel.attributes.Information = templateDefault.attributes.Information;
                tmpModel.attributes.Category01 = templateDefault.attributes.Category01;
                tmpModel.attributes.Category02 = templateDefault.attributes.Category02;
                tmpModel.attributes.Category03 = templateDefault.attributes.Category03;
                tmpModel.attributes.WebpageImageUrl = templateDefault.attributes.WebpageImageUrl;
                tmpModel.attributes.QRCodeImageUrl = templateDefault.attributes.QRCodeImageUrl;
                tmpModel.attributes.Data = templateDefault.attributes.Data;
            }
            else {
                tmpModel.attributes.Event = templateEmpty.attributes.Event;
                tmpModel.attributes.CultureName = templateEmpty.attributes.CultureName;
                tmpModel.attributes.Name = templateEmpty.attributes.Name;
                tmpModel.attributes.EventName = templateEmpty.attributes.EventName;
                tmpModel.attributes.Description = templateEmpty.attributes.Description;
                tmpModel.attributes.Information = templateEmpty.attributes.Information;
                tmpModel.attributes.Category01 = templateEmpty.attributes.Category01;
                tmpModel.attributes.Category02 = templateEmpty.attributes.Category02;
                tmpModel.attributes.Category03 = templateEmpty.attributes.Category03;
                tmpModel.attributes.WebpageImageUrl = templateEmpty.attributes.WebpageImageUrl;
                tmpModel.attributes.QRCodeImageUrl = templateEmpty.attributes.QRCodeImageUrl;
                tmpModel.attributes.Data = templateEmpty.attributes.Data;
            }

            self.app.entities.collections.customEventTemplate.fullCollection.create(tmpModel, {
                wait: true,
                sourceId: sourceId,
                destId: destId,
                success: function (response) {
                    callbackCopyTemplateDone(destId);

                    //var dialogBoxModel = new Entities_Empty.Model();
                    //dialogBoxModel.attributes.Title = resources.X100244;
                    //dialogBoxModel.attributes.Text = resources.X101479;
                    //dialogBoxModel.attributes.Button = resources.X100279;

                    //var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: this });
                    //var callback = function (options) {
                    //    this.stopListening(dialogBox, "dialog:okclicked", callback);
                    //}
                    //this.listenTo(dialogBox, "dialog:okclicked", callback);
                    //this.app.dialogRegion.show(dialogBox);
                }
            });
        }

        var callbackCopyTemplateDone = function (id) {

            self.refreshEntities(id, callback);


        }

        if (name != '') {

            var dialogWaitingModel = new Entities_Empty.Model();
            dialogWaitingModel.attributes.Title = resources.X100070;
            dialogWaitingModel.attributes.Text = resources.X100305;
            dialogWaitingModel.attributes.Button = resources.X100279;

            var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });

            var callback = function (id) {
                dialogWaiting.triggerMethod('dialog:close');
                self.stopListening(dialogWaiting, "dialog:okclicked", callback);

                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: id });
                customEvent[0].attributes.Category01 = categoryNone.attributes.Value;
                customEvent[0].attributes.Category02 = categoryNone.attributes.Value;
                customEvent[0].attributes.Category03 = categoryNone.attributes.Value;

                var render = new View_Render({ collection: customEvent, app: self.app });
                self.app.renderRegion.show(render);
                var renderFinishCallback = function (options) {
                    var scroll = $(document).scrollTop();
                    window.app.router.navigate("#customEventEditItem/" + id);
                    var scroll = $(document).scrollTop();

                    var showMessageEnable = false;
                    if (customEvent[0].attributes.Enable == false) showMessageEnable = true;


                    window.app.router.customEventEditItem(id, scroll, 0, true, showMessageEnable);
                }
                render.doIt(renderFinishCallback, true, 'EVENTINFO_REFRESH', false);
            }
            self.listenTo(dialogWaiting, "dialog:okclicked");
            self.app.dialogRegion.show(dialogWaiting);

            var lat = 0;
            var lng = 0;

            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'address': this.app.entities.models.custom.attributes.Address_country }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    lat = results[0].geometry.location.lat();
                    lng = results[0].geometry.location.lng();

                    helper_createEvent.createEventFromTemplate(app, self, lat, lng, name, callbackCreateEventDone);

                } else {
                    lat = 0;
                    lng = 0;

                    helper_createEvent.createEventFromTemplate(app, self, lat, lng, name, callbackCreateEventDone);
                }
            });
        } else {
            var count = 0;
            app.entities.collections.customEvent.fullCollection.forEach(function (entry) {
                if (entry.Enable) count++;
            });

            var message = String.format(resources.X200378, app.entities.models.customItem.attributes.Count, "http://shopify");

            var dialogBoxModel = new Entities_Empty.Model();
            dialogBoxModel.attributes.Title = resources.X100303;
            dialogBoxModel.attributes.Text = message;
            dialogBoxModel.attributes.Button = resources.X100279;

            var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: this });
            var callback = function (options) {
                this.stopListening(dialogBox, "dialog:okclicked", callback);
            }
            this.listenTo(dialogBox, "dialog:okclicked", callback);
            this.app.dialogRegion.show(dialogBox);
        }
    },
    refreshEntities: function (id, callback) {
        var self = this;
        $.when(
            self.app.entities.collections.customEvent.fetch({
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            app.entities.collections.customWebpage.fetch({
                fetchSingle: true,
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            app.entities.collections.customQRCode.fetch({
                fetchSingle: true,
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            app.entities.collections.customSchemaModel.fetch({
                fetchSingle: true,
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            app.entities.collections.customFormModel.fetch({
                fetchSingle: true,
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            app.entities.collections.customFormData.fetch({
                fetchSingle: true,
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            self.app.entities.collections.customModule.fetch({
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            self.app.entities.collections.customWebpageItem.fetch({
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            self.app.entities.collections.customSchemaSchema.fetch({
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            self.app.entities.collections.customEventLive.fetch({
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            self.app.entities.collections.customAd.fetch({
                EventId: id,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            })
            //self.app.entities.collections.customQRCode.fetch({
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //}),
            //self.app.entities.collections.customSchemaModel.fetch({
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //}),
            //self.app.entities.collections.customSchemaSchema.fetch({
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //}),
            //self.app.entities.collections.customFormModel.fetch({
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //}),
            //self.app.entities.collections.customWebpageItem.fetch({
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //}),
            //self.app.entities.collections.customModule.fetch({
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //}),
            //self.app.entities.collections.customWebpage.fetch({
            //    DisplayType: 0,
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //}),
            //self.app.entities.collections.customEventTemplate.fetch({
            //    getVersion: 1,
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //}),
            //self.app.entities.collections.customAd.fetch({
            //    getVersion: 1,
            //    success: function (mode, response) {
            //    },
            //    error: function (mode, response) {
            //    }
            //})
        ).done(function () {
            self.app.entities.collections.customEvent.fullCollection.sort();
            callback(id);
        });
    },
    btnSubmitTest: function () {
        var self = this;

        var counter = 0;
        var maxCounter = 40;
        var flag = true;

        var currentEvent = 0;

        //Online
        //var event1  = {id : 119, Webpage: 53, Infopage: 51, QRCode: 129, SchemaModel : 13, FormModel : 7}; 
        //var event2  = {id : 120, Webpage: 52, Infopage: 50, QRCode: 128, SchemaModel : 12, FormModel : 6}; 

        var length = self.app.entities.collections.customEvent.fullCollection.length;

        if (length >= 2) {

            //var event1  = {id : 2197, Webpage: 1018, Infopage: 1009, QRCode: 48, SchemaModel : 2, FormModel : 1}; 
            //var event2  = {id : 2197, Webpage: 1021, Infopage: 1020, QRCode: 55, SchemaModel : 3, FormModel : 2}; 

            var event1 = {
                id: self.app.entities.collections.customEvent.fullCollection.models[length - 1].attributes.id,
                Webpage: self.app.entities.collections.customEvent.fullCollection.models[length - 1].attributes.Webpage,
                Infopage: self.app.entities.collections.customEvent.fullCollection.models[length - 1].attributes.Infopage,
                QRCode: self.app.entities.collections.customEvent.fullCollection.models[length - 1].attributes.QRCode,
                SchemaModel: self.app.entities.collections.customEvent.fullCollection.models[length - 1].attributes.SchemaModel,
                FormModel: self.app.entities.collections.customEvent.fullCollection.models[length - 1].attributes.FormModel
            };

            var event2 = {
                id: self.app.entities.collections.customEvent.fullCollection.models[length - 2].attributes.id,
                Webpage: self.app.entities.collections.customEvent.fullCollection.models[length - 2].attributes.Webpage,
                Infopage: self.app.entities.collections.customEvent.fullCollection.models[length - 2].attributes.Infopage,
                QRCode: self.app.entities.collections.customEvent.fullCollection.models[length - 2].attributes.QRCode,
                SchemaModel: self.app.entities.collections.customEvent.fullCollection.models[length - 2].attributes.SchemaModel,
                FormModel: self.app.entities.collections.customEvent.fullCollection.models[length - 2].attributes.FormModel
            };

            var event = [];
            event.push(event1);
            event.push(event2);

            var callback_event_render = function (id) {
                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: event[0].id })

                self.app.renderRegion.empty();

                var renderFinishCallback = function (options) {
                    callback();
                }

                var timerId = window.setInterval(function () {
                    clearInterval(timerId);
                    var render = new View_Render({ collection: customEvent, app: self.app });
                    self.app.renderRegion.show(render);
                    render.doIt(renderFinishCallback, false, 'EVENT_REFRESH', false);
                }, 1000);
            }

            var callback = function () {
                currentEvent++;
                if (currentEvent >= event.length) {
                    currentEvent = 0;
                }

                var customEvent = app.entities.collections.customEvent.fullCollection.where({ id: event[0].id });

                if (customEvent[0].attributes.Webpage == event[currentEvent].Webpage) {
                    callback();
                }

                customEvent[0].attributes.Webpage = event[currentEvent].Webpage;
                customEvent[0].attributes.Infopage = event[currentEvent].Infopage;
                customEvent[0].attributes.QRCode = event[currentEvent].QRCode;
                customEvent[0].attributes.SchemaModel = event[currentEvent].SchemaModel;
                customEvent[0].attributes.FormModel = event[currentEvent].FormModel;
                customEvent[0].attributes.WebpageImageUrl = '';
                customEvent[0].attributes.QRCodeImageUrl = '';
                customEvent[0].attributes.ChecksumEventHeader = '';
                customEvent[0].attributes.ChecksumEventTemplate = '';
                //customEvent[0].attributes.ChecksumEventInfoHeader = '';
                //customEvent[0].attributes.ChecksumEventInfoTemplate = '';
                customEvent[0].attributes.ChecksumEventIndex = '';
                //customEvent[0].attributes.ChecksumEventTextFileJson = '';
                customEvent[0].attributes.ChecksumQRCodeImageUrl = '';
                //customEvent[0].attributes.ChecksumWebpageImageIndex = '';
                customEvent[0].attributes.ChecksumWebpageImageUrl = '';
                customEvent[0].attributes.ChecksumEventImageFile = '';
                customEvent[0].attributes.ChecksumEventManifestJson = '';
                customEvent[0].attributes.ChecksumEventServiceWorkerJs = '';

                customEvent[0].save(customEvent[0].attributes, {
                    wait: true,
                    silent: true,
                    success: function () {
                        if (counter < maxCounter) {
                            callback_event_render(customEvent[0].attributes.id);
                        }
                        counter++;
                    },
                    error: function () {
                    }
                });
            }

            callback();
        }
    }
});

